import { methodDraft, tierDraft } from '@/composables/useWizardDraft'
import { buildSellNavItems, SELL_BASES } from '@/config/sellNav'
import { PARSLEY_CAPABILITY } from '@/helpers/parsley'

export default {
  bases: SELL_BASES,
  // A function of the nav context so the tiers are only requested when the plan has the membership program.
  fetches: ({ featureState = () => 'on' } = {}) => [
    'stores?included=none',
    'fulfillment_methods?included=none',
    ...(featureState('membership_program') === 'on' ? ['membership_tiers?included=none'] : [])
  ],
  build: ({ isCatering, capabilities = [], expanded, revealed, mapType, path, featureState = () => 'on' }) =>
    buildSellNavItems({
      isCatering,
      parsley: capabilities.includes(PARSLEY_CAPABILITY),
      stores: mapType('store'),
      fulfillmentMethods: mapType('fulfillment_method'),
      membershipTiers: mapType('membership_tier'),
      draftTier: tierDraft.name.value,
      draftMethod: methodDraft.name.value,
      expanded,
      revealed,
      featureState,
      path
    })
}
